import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta' 
import store from '@/state/store'  
import routes from './routes'; 
   
Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

var router = new VueRouter({
  routes: routes, 
  mode: 'history', 
})

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
 
  if(routeTo.params.slug)
    document.title = routeTo.params.slug
 
  const publicPages = ['/login', 
  '/register','/register_ame', '/company', 
  '/company/member','/forgot-password', 
  '/reset-password', '/validation', '/program-list', '/:slug']; 
  const authpage = !publicPages.includes(routeTo.path);
  const loggeduser = store.getters['getLoggedIn'];
 
  if (authpage && !loggeduser && !routeTo.meta.slug) {  
    await store.dispatch('setRouteTo', routeTo.fullPath);
    
    return next('/login');
  } 
   
  next(); 
  
})
 

export default router
